module.exports = __webpack_public_path__ + "blackwaterbottle.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackwaterbottle.png
// module id = 873
// module chunks = 0